import { ColorScheme, Map, RenderingType } from '@vis.gl/react-google-maps';
import { Spin } from 'antd';
import React, { forwardRef } from 'react';
import { defaultMapConfig } from './VisGLMap.constants';
import { LoadingOverLay, PopupContainer, StyledMap } from './VisGLMap.styles';
import { VisGLMapProps } from './VisGLMap.types';
import { useAppConfig } from 'app/cross-cutting-concerns/configuration/hooks/useAppConfig';

export const VisGLMap = forwardRef<HTMLDivElement, VisGLMapProps>(({ isLoading, children, ...mapProps }, ref) => {
  const {
    googleMaps: { mapId },
  } = useAppConfig();

  return (
    <StyledMap>
      <PopupContainer ref={ref} data-loading={String(isLoading)}>
        <Map
          {...defaultMapConfig}
          {...mapProps}
          mapId={mapId}
          reuseMaps={false}
          colorScheme={ColorScheme.LIGHT}
          renderingType={RenderingType.VECTOR}
        >
          {children}
        </Map>

        {isLoading && (
          <LoadingOverLay>
            <Spin />
          </LoadingOverLay>
        )}
      </PopupContainer>
    </StyledMap>
  );
});

VisGLMap.displayName = 'VisGLMap';
